import React, { Fragment, useEffect, useRef, useState } from "react";
import { Row, Col, Input, Progress, Alert, Space, Tooltip } from "antd";
import "./styles.css";
import { CgAttachment } from "react-icons/cg";
import { AiFillCloseCircle } from "react-icons/ai";
import {
  getFileIcon,
  getFileSizeInfo,
} from "../../../../components/fileinformation";
import TopAlert from "../../../../components/TopNotification/TopAlert";
import { WS } from "../../../../webSocket/defaultSocket";
import { useDispatch, useSelector } from "react-redux";
import {
  receivedMessage,
  receivedMessageFailure,
  receivedMessageInit,
  sendMessage_Attachment,
} from "../../../../redux/actions";
import Compressor from 'compressorjs';
import axios from "axios";
import { fetchToken } from "../../../../API/API";
import Loader from "../../../../components/Loading/Loader";
import { LoadingOutlined } from "@ant-design/icons";
import video from "../../../../assets/icons/video.svg";
import InterviewDrawer from "../../../ProfileDetail/InterviewDrawer/interviewDrawer";

const MessageInput = ({
  setAlertMsg,
  chatDetails,
  currentUser,
  setErrorTitle,
  itemId,
  jobTitle
}) => {
  const dispatch = useDispatch();
  const inputTextArea = useRef(null);
  const inputAttachmentBox = useRef(null);
  const BackendApiBaseUrl = process.env.REACT_APP_API_URL;
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const bidStatus = useSelector((state) => state.messagesReducer.bidStatus);

  const [attachmentFile, setAttachmentFile] = useState([]);
  const [textArea, setTextArea] = useState(null);
  const [textAreaValue, setTextAreaValue] = useState();
  const [socketFile, setSocketFiles] = useState([]);
  const [fileKey, setFileKey] = useState([]);
  const [UploadLoading, setUploadLoading] = useState(0);
  const [UploadCheck, setUploadCheck] = useState(true);
  const [error, setError] = useState(false);
  const [docUploadcheck,setDocUploadcheck] = useState(false);
  const [compressedFile, setCompressedFile] = useState(null);
  const [showInterviewDrawer, setShowInterviewDrawer] = useState(false);
  //Reducers
  const uploadFileRes = useSelector(
    (state) => state.messagesReducer.uploadFileRes
  );
  
  const sendMessageLoading = useSelector(state => state.messagesReducer.sendMessageLoading)
  // adding s3keys & Urls according to their files
  useEffect(() => {
    if (fileKey.length == attachmentFile.length) {
      setAttachmentFile(
        attachmentFile.map((res, index) => {
          return {
            ...res,
            FileInfo: {
              FilePath: fileKey[index].file,
              FileName: res.file.name,
              FileSize: res.file.size,
              FileUrl: fileKey[index]?.fileUrl,
            },
          };
        })
      );
    }
  }, [fileKey]);

  // setting an array to use for sockets
  useEffect(() => {
    var tempoArr = [];
    for (let index = 0; index < attachmentFile.length; index++) {
      if (attachmentFile.length > 0) {
        tempoArr = [
          ...tempoArr,
          {
            FileName: attachmentFile[index].file.name,
            FilePath: attachmentFile[index].FileInfo?.FilePath,
            FileSize: attachmentFile[index].file.size,
          },
        ];
      }
    }
    setSocketFiles(tempoArr);
  }, [attachmentFile]);

  // Upload Files on S3 bucket
  async function uploadToBucket() {
    const results = [];
    for (let i = 0; i < attachmentFile.length; i++) {
      try {
        if (attachmentFile[i].FileInfo?.FileUrl) {
          const uploadRequestS3 = await axios.put(
            attachmentFile[i].FileInfo.FileUrl,
            attachmentFile[i].file
          );
          results.push(uploadRequestS3);
        }
      } catch (err) {
        results.push(err);
      }
    }
    return results;
  }



  const onChangeFile = async ({ target: { files } }) => {
    const image = files[0];
    
    let flag = false;
    const length = files.length;
    for (let i = 0; i < length; i++) {
      let Compressed_File = null;
      let ImageCheck = false;
      if (files[i].type.startsWith('image/')){
        ImageCheck = true;
        Compressed_File = await new Promise((resolve) => {
          new Compressor(files[i], {
            quality: 0.6,
            resize: 'cover',
            maxHeight: 800,
            maxWidth: 800,
            success: (compressedFile) => resolve(compressedFile),
          });
        });
      }
      const fileIcon = getFileIcon(getFileFormat(ImageCheck ? Compressed_File?.name: files[i].name));
      if (fileIcon) {
        const fileSize = getFileSizeInfo(ImageCheck ? Compressed_File: files[i]);
        if (fileSize) {
          setAttachmentFile((prevState) => {
            return [...prevState, { file: ImageCheck ? Compressed_File: files[i] }];
          });

          const payload = {
            type: "msgAttachment",
            contentType: ImageCheck ? Compressed_File?.type: files[0]?.type,
          };

          const headers = await fetchToken();
          // const getUploadUrl = `http://192.168.1.104:4000/development/upload`;
          const getUploadUrl = `${BackendApiBaseUrl}/upload`;
          setUploadLoading(80);
          setUploadCheck(false);
          let response = "";
          try {
            const data = await axios.post(getUploadUrl, payload, { headers });
            response = data.data;
            if (response) {
              setUploadLoading(100);
              setUploadCheck(true);
            }
          } catch (error) {
            setError(true);
          }
          setFileKey([
            ...fileKey,
            {
              file: response?.Key,
              fileUrl: response?.uploadURL,
            },
          ]);
          // dispatch(
          //   sendMessage_Attachment({
          //     type: "msgattachment",
          //     contentType: files[i].type,
          //     folder: "userDocs",
          //   })
          // );
          // setAlertMsg(true);
        } else {
          setErrorTitle("File size bigger than 10 MB");
          setAlertMsg(true);
        }
        if (i === 0 && length === 1 && !fileSize) flag = true;
      } else {
        setErrorTitle("File format not supported");
        setAlertMsg(true);
      }
      if (i === 0 && length === 1 && !fileIcon) flag = true;
    }
    flag ? getDispayBlock() : getDispayNone("fromFileAttachment");
  };

  const onRemoveAttachment = (fileName, e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    setAttachmentFile(() => {
      return attachmentFile.filter((file) => {
        return file.file.name !== fileName;
      });
    });
    var filterKey = attachmentFile.filter((file) => {
      return file.file.name === fileName;
    });
    setFileKey(() => {
      return fileKey.filter((file) => {
        return file.file !== filterKey[0]?.FileInfo?.FilePath;
      });
    });
    getDispayNone("onRemoveAttachment");
  };

  const getFileFormat = (fileName) => {
    const behideDot = fileName?.lastIndexOf(".") + 1;
    const fileLength = fileName?.length;
    const fileFormat = fileName?.slice(behideDot, fileLength);
    return fileFormat;
  };

  const textAreaAdjust = (element) => {
    const val = element.target.value;
    if (val !== "") {
      element.target.style.height = -2 + element.target.scrollHeight + "px";
    } else {
      element.target.style.height = "40px";
      if (window.innerWidth < 768) element.target.style.height = "53px";
    }
    setTextArea(element);
    setTextAreaValue(element.target.value);
  };

  const onFocusTextArea = () => {
    if (attachmentFile.length !== 0) {
      getMarginInputAttachmentBox("marginTop-15px");
    }
  };

  const getMarginInputAttachmentBox = (str) => {
    switch (str) {
      case "marginTop_0px":
        inputAttachmentBox.current.style.marginTop = "0px";
        break;

      case "marginTop-15px":
        inputAttachmentBox.current.style.marginTop = "-15px";
        break;

      default:
        inputAttachmentBox.current.style.margin = "0px";
        break;
    }
  };

  const handleOnCLickTextAreaFocus = () => {
    getDispayBlock("fromTextWithAttachment");
  };

  const getDispayBlock = (str) => {
    switch (str) {
      case "fromFileAttachment":
        getMarginInputAttachmentBox("marginTop-15px");
        getDispayBlock();
        break;

      case "onRemoveAttachment":
        getMarginInputAttachmentBox("marginTop-15px");
        getDispayBlock();
        if (textArea?.target?.value && attachmentFile.length === 1) {
          getMarginInputAttachmentBox(" marginTop_0px");
        }
        break;

      case "fromTextWithAttachment":
        if (attachmentFile.length !== 0) {
          getMarginInputAttachmentBox("marginTop-15px");
          getDispayBlock();
          inputTextArea.current.focus();
        }
        break;

      default:
        inputTextArea.current.style.display = "block";
        break;
    }
  };

  const getDispayNone = (str) => {
    switch (str) {
      case "fromFileAttachment":
        !textArea?.target?.value
          ? getDispayNone()
          : getDispayBlock("fromFileAttachment");
        break;

      case "onRemoveAttachment":
        !textArea?.target?.value
          ? (inputTextArea.current.style.display = "block")
          : getDispayBlock("onRemoveAttachment");
        break;

      default:
        // inputTextArea.current.style.display = "none";
        getMarginInputAttachmentBox();
        break;
    }
  };

  const AttachmentDiv = ({ file: { name: fileName } }) => {
    return (
      <>
        <div className="attachment-container">
          <div className="attachment-content">
            <img
              src={getFileIcon(getFileFormat(fileName))}
              // alt={fileName}
              className="fileIcon"
            />
            <div className="attachment-content-info">
              <h3>{fileName}</h3>
              <p>{getFileFormat(fileName)}</p>
            </div>
          </div>
          <AiFillCloseCircle
            className="attachment-container-close-btn"
            onClick={(e) => onRemoveAttachment(fileName, e)}
          />
        </div>
      </>
    );
  };
  function InitMessageSend(){
    dispatch(receivedMessageInit());
  }
  async function onSubmitHandler(event) {
    InitMessageSend();
    let success = await uploadToBucket()??[];
    setAttachmentFile([]); //clears the attachment array
    setFileKey([]);
    inputTextArea.current.style.height = "40px"; //resets the height of textarea
    let failure = [];

    if (success?.length > 0) {
      failure = success?.filter((res) => {
        return res?.status !== 200
      })
    }
    
    if (failure?.length > 0 && attachmentFile?.length > 0){
      setDocUploadcheck(true)
      dispatch(receivedMessageFailure());
    }

    if (attachmentFile?.length == 0 && textAreaValue.trim()?.length<1) {
      // console.log('condition>>>> if')
      dispatch(receivedMessageFailure());
      inputTextArea.current.value = ""; //clears the input field
        setTextAreaValue('')
      return;
    } else { //send msg in sockets
      // console.log('condition>>>> else',/^\s*$/.test(textAreaValue),attachmentFile?.length == 0,textAreaValue?.length<1)
      if(!error && failure?.length === 0) {
        WS.sendMessage(
          JSON.stringify({
            action: "sendMessage",
            // users: chatDetails[0].RecipientUserId,
            users:
              chatDetails[0]?.RecipientUser?.AccountId == userProfile?.AccountId
                ? chatDetails[0]?.SenderUser?.AccountId
                : chatDetails[0]?.RecipientUser?.AccountId,
            data: textAreaValue,
            SourceId: chatDetails[0]?.SourceId,
            ConversationId: chatDetails[0]?.ConversationId,
            Type: 'EMP',
            // onModel: "SkillListings",
            SourceTypeId: chatDetails[0].SourceTypeId,
            SourceName: chatDetails[0].GigCard.Title,
            SecondarySourceId: chatDetails[0].SecondarySourceId,
            SecondarySourceTypeId: chatDetails[0].SecondarySourceTypeId,
            HasAttachments: attachmentFile.length > 0 ? true : false,
            attachments: socketFile.length > 0 ? socketFile : null,
            GigTitle: jobTitle ?? 'Gig Title'
          })
        );
        inputTextArea.current.value = ""; 
        setTextAreaValue('')
      }
    }
    //receive msg to display
    // dispatch(
    //   receivedMessage({
    //     data: textAreaValue,
    //     users: chatDetails[0].RecipientUserId,
    //     senderId: currentUser,
    //     SecondarySourceTypeName: "Bid",
    //     SourceTypeName: chatDetails[0].SourceTypeName,
    //     attachments: socketFile.length > 0 ? socketFile : null,
    //   })
    // );
  }

  const handleKeyPress = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault(); // helping in no extra space
      // Enter key is pressed without Shift key
      onSubmitHandler();
    }
  };

  const handleInterviewDrawer = () => {
    setShowInterviewDrawer(true);
  };

  const isVideoIconDisabled = () => {
    return (
      bidStatus.includes("Declined Bid") ||
      bidStatus.includes("Offer Declined") ||
      bidStatus.includes("Interview Cancelled") ||
      bidStatus.includes("Hired") ||
      bidStatus.includes("On Billing") ||
      bidStatus.includes("Off Billing") ||
      !bidStatus.includes("Profile Submitted")
    );
  };

  useEffect(() => {
    setTimeout(() => {
      setDocUploadcheck(false)
    }, 5000);
  },[docUploadcheck])

  useEffect(() => {
    if (error || docUploadcheck) {
      setAttachmentFile([]);
    }
    setTimeout(() => {
      setError(false);
      setUploadLoading(100);
    }, 3000);
  }, [error || docUploadcheck]);
  return (
    <Fragment>
      {/*    BidType: source == 1 ? "Bid" : "Proposal", */}
   {showInterviewDrawer ?   <InterviewDrawer
        reSchedule={false}
        interviewId={undefined}
        bid={chatDetails?.[0]?.SecondarySourceId}
        timings={undefined}
        editScheduleInterviewHook={false}
        open={showInterviewDrawer}
        close={setShowInterviewDrawer}
        bidType={chatDetails?.[0]?.SourceTypeId}
      />:null}
      <div
        style={{
          bottom: "0",
          padding: "0% 1.5% 0% 1.5%",
          width: "100%",
          zIndex: "1",
          backgroundColor: "#fff",
        }}
        className="send-message-container"
      >
        <div
          className="text-with-attachment"
          style={{
            boxShadow:
              attachmentFile.length > 0 && "0 0 0.25rem 0 rgba(0, 0, 0, 0.25)",
          }}
        >
          <textarea
            name=""
            id=""
            placeholder="Add your message..."
            className="teaxArea-content ant-input"
            onChange={(e) => {
              textAreaAdjust(e);
            }}
            ref={inputTextArea}
            style={{
              boxShadow:
                attachmentFile.length > 0
                  ? "none"
                  : "0 0 0.25rem 0 rgba(0, 0, 0, 0.25)",
            }}
            // onBlur={onBlurTextArea}
            onFocus={onFocusTextArea}
            onKeyDown={handleKeyPress}
          ></textarea>

          <div
            className="attachment-box"
            ref={inputAttachmentBox}
            onClick={handleOnCLickTextAreaFocus}
          >
            {error || docUploadcheck ? (
              <Alert
                type="error"
                showIcon={false}
                message="Document failed to upload please reload and try again"
                banner
              />
            ) : UploadLoading > 0 && UploadLoading < 100 ? (
              <div className="upload-progress">
                <Progress
                  percent={UploadLoading}
                  status="active"
                  size="small"
                />
              </div>
            ) : (
              attachmentFile.map((file, i) => (
                <AttachmentDiv key={i} file={file.file} />
              ))
            )}
          </div>
          {/* <Input placeholder="Type your Message here" className="messageInput" /> */}
        </div>

        <div className="message-bottom">
          <div className="conversation-icon flex">
            <label htmlFor="file">
              <CgAttachment className="conversation-icon" />
            </label>
            <input
              type="file"
              id="file"
              style={{ display: "none" }}
              onChange={(e) => onChangeFile(e)}
              multiple
            />
            <Tooltip title="Schedule Interview" placement="bottom">
              <button
                onClick={handleInterviewDrawer}
                style={{
                  outline: "none",
                  border: "none",
                  background: "transparent",
                  margin: "0px 0px 2px 10px",
                  paddingBottom: "2px",
                }}
                disabled={isVideoIconDisabled()}
              >
                <img alt="video-icon" src={video} className="video-icon" />
              </button>
            </Tooltip>
          </div>
          {sendMessageLoading ? (
            <div>
              <LoadingOutlined />
            </div>
          ) : (
            <button
              className={
                UploadCheck ? "message-send-btn" : "message-send-btn-disabled"
              }
              onClick={(e) => onSubmitHandler(e)}
              disabled={!UploadCheck}
            >
              Send
            </button>
          )}
        </div>
      </div>
    </Fragment>
  );
};
export default MessageInput;
